import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen bg-navy-dark" data-id="element-147">
      <HeroSection data-id="element-148" />
      <ProblemSection data-id="element-149" />
      <SolutionSection data-id="element-150" />
      <OfferSection data-id="element-151" />
      <Footer data-id="element-152" />
    </main>;
}